const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20bridge%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20cinematic%20sci-fi%20interior%2C%20golden%20and%20blue%20accent%20lights%2C%20dramatic%20atmosphere%2C%20no%20text%20no%20faces&width=800&height=500&seq=media-movie-01&orientation=landscape',
    title: '星际迷航：新纪元',
    duration: '2:38',
    tag: '正式预告',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20temple%20courtyard%20in%20rain%20with%20martial%20arts%20atmosphere%2C%20warm%20lantern%20glow%2C%20misty%20mountain%20background%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%20no%20faces&width=800&height=500&seq=media-movie-02&orientation=landscape',
    title: '夜雨江湖',
    duration: '1:52',
    tag: '精彩片段',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20underwater%20ancient%20city%20ruins%20with%20bioluminescent%20glow%2C%20divers%20silhouettes%20in%20distance%2C%20cinematic%20deep%20sea%20atmosphere%2C%20teal%20and%20amber%20lighting%2C%20no%20text%20no%20faces&width=800&height=500&seq=media-movie-03&orientation=landscape',
    title: '深海迷城',
    duration: '2:15',
    tag: '先导预告',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20wilderness%20landscape%20at%20dusk%20with%20dramatic%20storm%20clouds%2C%20isolated%20cabin%20in%20distance%2C%20thriller%20cinematic%20atmosphere%2C%20moody%20amber%20and%20charcoal%20lighting%2C%20no%20text%20no%20faces&width=800&height=500&seq=media-movie-04&orientation=landscape',
    title: '荒野追凶',
    duration: '1:45',
    tag: '幕后花絮',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Enchanted%20moonlit%20bamboo%20forest%20with%20floating%20spirit%20lights%2C%20fantasy%20dreamscape%20atmosphere%2C%20soft%20ethereal%20golden%20and%20silver%20glow%2C%20cinematic%20fairy%20tale%20composition%2C%20no%20text%20no%20faces&width=800&height=500&seq=media-movie-05&orientation=landscape',
    title: '月下奇谭',
    duration: '2:02',
    tag: '主题曲MV',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 border border-secondary-200 mb-4">
            <i className="ri-clapperboard-line text-secondary-600 text-sm"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">精彩预告</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            精彩预告
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            热门电影精彩预告与幕后花絮，提前感受大片魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-950/60 backdrop-blur group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl md:text-3xl text-foreground-950 ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 backdrop-blur">
                  <span className="text-xs font-mono text-foreground-700 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500/90 text-foreground-950 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}